'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitcherModal = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitcherModal = exports.SwitcherModal = function SwitcherModal(_ref) {
  var header = _ref.header,
      onClickOption = _ref.onClickOption,
      options = _ref.options;
  return _react2.default.createElement(
    'div',
    { className: 'SwitcherModal' },
    header && _react2.default.createElement(
      'header',
      { className: 'SwitcherModal__header' },
      header
    ),
    options.map(function (_ref2) {
      var display = _ref2.display,
          value = _ref2.value,
          selected = _ref2.selected;
      return _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return onClickOption(value);
          },
          key: value,
          className: (0, _classnames2.default)('SwitcherModal__item', {
            'is-active': selected
          })
        },
        display
      );
    })
  );
};

SwitcherModal.propTypes = {
  header: _propTypes2.default.element,
  onClickOption: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    display: _propTypes2.default.string,
    selected: _propTypes2.default.bool,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  }))
};